import { FUNDS_AND_PORTFOLIOS_PATH } from '@upright/ui/common/generic/components/navigation/page-paths';

export function generateHomeUrl({
  entity,
  isInvestorFrontPage = true,
  isCompanyFrontPage = false,
}: {
  entity: 'investor' | 'company';
  isInvestorFrontPage?: boolean;
  isCompanyFrontPage?: boolean;
}) {
  const investorHomeViewUrl = isInvestorFrontPage ? '/' : FUNDS_AND_PORTFOLIOS_PATH;
  const dashBoardUrl = isCompanyFrontPage ? '/' : '/company-dashboard';
  return entity === 'company' ? dashBoardUrl : investorHomeViewUrl;
}
